import State from '../core/State';
import FacebookAccessToken from '../entity/FacebookAccessToken';
import initialState from '../initialState';

export const setFacebookAccessToken = (facebookAccessToken: FacebookAccessToken) => (state: State): State => ({
  ...state,
  facebookAccessToken,
});

export const disposeFacebookAccessToken = () => (state: State): State => ({
  ...state,
  facebookAccessToken: initialState.facebookAccessToken,
});
